import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { ColdCompressActionV2 } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-cold-compress-slot-v2',
    templateUrl: './cold-compress-slot-v2.component.html',
    styleUrl: './cold-compress-slot-v2.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ColdCompressSlotComponentV2 implements SheetSlotComponentBase {

	@Input() action!: ColdCompressActionV2;
	value = null;

	constructor() {
	}
}